module.exports = __webpack_public_path__ + "img/pr-1.ad8d187c.png";